export const EDX_LOGIN_COOKIE = "edxloggedin";

const SHOW_UNITS_DROPDOWN = true;
const SHOW_UNITS_NAVIGATIONS = false;

const SUBMISSION_STATUS = {
  UNSUBMITTED: "unsubmitted",
  SUBMITTING: "submitting",
  SUBMITTED: "submitted",
  FAILED: "failed",
};

const LOADING_STATUS = {
  STANDBY: "standby", // Structure has been created but is not yet loading.
  LOADING: "loading",
  LOADED: "loaded",
  FAILED: "failed",
};

export {
  SHOW_UNITS_DROPDOWN,
  SHOW_UNITS_NAVIGATIONS,
  SUBMISSION_STATUS,
  LOADING_STATUS,
};

export const NOTIFICATION_TYPES = {
  evaluationRequest: "evaluation_request",
  evaluationRequestReview: "evaluation_request_review",
  feedbackSent: "feedback_sent",
  feedbackRequested: "feedback_requested",
  completionRequest: "completion_request",
  courseEnrollment: "course_enrollment",
  completionReview: "completion_review",
  badgeEarned: "badge_earned",
  completionReviewNotifyBCM: "completion_review_notify_bcm",
  resourceShared: "resource_shared",
  evaluationDirectReview: "evaluation_direct_review",
  preCourseEnrollment: "pre_course_enrollment",
  completionRequestFirstReminder: "completion_request_first_reminder",
  completionRequestSecondReminder: "completion_request_second_reminder",
  feedbackBadgeEarned: "feedback_badge_earned",
  courseInactivity: "course_inactivity",
  pathwaysMentorProgramEnrollment: "pathways_mentor_program_enrollment",
  clubCoachModuleEnrollment: "club_coach_module_enrollment",
  speechcrafterCertificate: "speechcrafter_certificate",
  speechcrafterLastSelfAssessment: "speechcrafter_last_self_assessment",
  speechcraftEventEnd: "end_speechcraft_event",
  clubAssociationChange: "club_association_change",
  reverse_completion_project: "reverse_completion_project",
  reverse_completion_level: "reverse_completion_level",
  reverse_completion_path: "reverse_completion_path",
};

export const BADGE_HASH_TYPES = {
  learnerBadge: "#learner-badge",
  feedbackBadge: "#feedback-badge",
  speechBadge: "#speech-badge",
};

export const BADGE_TYPES = {
  learnerBadge: "PW",
  learnerFeedbackBadge: "PW_FB",
  speechFeedbackBadge: "SC_FB",
  speechBadge: "SC",
};

export const APPROVAL_REQUEST_STATUS = {
  Denied: "Denied",
  Pending: "Review",
  Approved: "Approved",
  Reversed: "Reversed",
};

export const NOTIFICATION_INTERVAL = 500000;

export const TOASTMASTERS_WEBSITE_URL =
  "https://www.toastmasters.org/start-pathways/select-your-preference";

export const Levels = {
  level1: "level-1",
  level2: "level-2",
  level3: "level-3",
  level4: "level-4",
  level5: "level-5",
};

export const Role = {
  coordinator: "EDLYSCC",
  speechcrafter: "EDLYSCA",
};

export const SUPPORTED_LANGUAGES = ["ar", "fr", "zh-cn", "de-de", "es-mx"];

export const TICourses = {
  PMP: "pathways mentor program",
  DTM: "distinguished toastmaster",
  CCP: "club coach program",
  CBI: "club building initiative",
};

export const EXPLORATIONS_CONTENT_GROUP_VALUE = 'explorations';
